/** get items column */
// import { TagItemTypes } from "../../../badge-and-tag/ERP";
export const columns = ()=>{
  return [
    {
      title: "รหัสบรรจุภัณฑ์",
      key: "pk_code",
      dataIndex: "pk_code", 
      width:"15%",
      sorter: (a, b) => (a?.pk_code || "").localeCompare(b?.pk_code || ""),
    },
    {
      title: "ชื่อบรรจุภัณฑ์",
      dataIndex: "pk_name",
      key: "pk_name",
      sorter: (a, b) => (a?.pk_name || "").localeCompare(b?.pk_name || ""),
      // width:"25%",
    },
    {
      title: "ชนิดบรรจุภัณฑ์",
      dataIndex: "typename",
      key: "typename",
      width:"15%",
      sorter: (a, b) => (a?.typename || "").localeCompare(b?.typename || ""),
    },
  ]
};